/**
 * Public chat view component that displays shared chat messages
 * This component renders a specific chat conversation that has been shared
 * via a public link, retrieved by the chatId from the URL params
 */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PublicLayout from '../layout';
import ChatList from '../../../components/chatList';
import { getChats } from './actions';

/**
 * Chats component for displaying publicly shared chat conversations
 * Fetches and renders a specific chat history based on the URL parameter
 */
const Chats: React.FC = () => {
  const { chatId } = useParams<{ chatId: string }>();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);

  /**
   * Fetches chat data from the API using the chatId from URL params
   */
  const getData = async () => {
    setIsLoading(true);
    const temp = await getChats(chatId);
    setData(temp);
    setIsLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <PublicLayout>
      <ChatList
        messages={data}
        isLoadingMessage={false}
        isLoading={false}
        firstName=""
        name=""
        isLoadingMessages={isLoading}
        onReadTextPress={() => {}}
        isSpeaking={false}
        categories={[]}
        onCategoryPress={() => {}}
        selectedCategory=""
        onDebugButtonPress={() => {}}
        onQuickQuestionPress={() => {}}
        onSharePress={() => {}}
        shared
      />
    </PublicLayout>
  );
};

export default Chats;
